import { render, staticRenderFns } from "./RevertRecoveryInfo.vue?vue&type=template&id=52b945ed&"
import script from "./RevertRecoveryInfo.vue?vue&type=script&lang=js&"
export * from "./RevertRecoveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports